<template>
  <base-modal hide-footer hide-header @close="$emit('close')">
    <h3 class="editor-header">{{ $t('observation_reports.add') }}</h3>
    <div class="col-sm-12">
      <div class="col-sm-12 editor-form">
        <div class="row px-2">
          <div class="col-sm-4 p-1">
            <span class="span-title">{{ $t('observation_reports.name') }}</span>
              <input
                  id="name"
                  v-model="report.name"
                  type="text"
                  class="form-control form-control-sm"
                  autocomplete="off"
              />
          </div>
          <div class="col-sm-4 p-1">
            <span class="span-title">{{ $t('observation_reports.observation_type') }}</span>
              <select
                  id="observationType"
                  v-model="observationType"
                  class="form-select form-select-sm"
              >
                  <option
                      v-for="(option, index) in observationTypes"
                      :key="index"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>
          <div class="col-sm-4 p-1">
            <span class="span-title">{{ $t('observation_reports.x_axis') }}</span>
              <select
                  id="xAxis"
                  v-model="report.x_axis"
                  class="form-select form-select-sm"
              >
                  <option
                      v-for="(option, index) in axisOptions"
                      :key="index"
                      :value="option.value"
                  >
                      {{ option.text }}
                  </option>
              </select>
          </div>
        </div>
        <div class="row px-2">
          <div class="col-sm-4 p-1">
            <span class="span-title">{{ $t('observation_reports.upper_alert') }}</span>
              <input
                  id="name"
                  v-model="report.upper_alert_limit"
                  type="text"
                  class="form-control form-control-sm"
                  autocomplete="off"
              />
          </div>
          <div class="col-sm-4 p-1">
            <span class="span-title">{{ $t('observation_reports.lower_alert') }}</span>
              <input
                  id="name"
                  v-model="report.lower_alert_limit"
                  type="number"
                  class="form-control form-control-sm"
                  autocomplete="off"
              />
          </div>
        </div>
        <div class="row">
          <span class="tip-light">{{ $t('observation_reports.alert_hint') }}</span>
        </div>
        <div class="col-sm-12 d-flex justify-content-end pt-2">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
            {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading||report===null"
            @click.stop="submit"
          >
            {{ $t('common.save') }}
          </button>
        </div>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </div>
  </base-modal>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import BaseModal from '../../BaseModal'
import {timeUtils} from "@/components/mixins/TimeUtils";
import {inject} from "vue";

export default {
    name: 'ObservationReportEditor',
    components: {BaseModal},
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            loading: false,
            observationType: null,
            observationTypes: [],
            report: {
                id: null,
                name: null,
                observation_type: null,
                x_axis: null,
                upper_alert_limit: null,
                lower_alert_limit: null
            },
            axisOptions: [
                {text: this.$t('observation_reports.x_time'), value: 1},
                {text: this.$t('observation_reports.x_road_number'), value: 2},
                {text: this.$t('observation_reports.x_road_section'), value: 3},
                {text: this.$t('observation_reports.x_street_name'), value: 4},
            ]
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted() {
        this.fetchObservationTypes()
    },
    methods: {
        fetchObservationTypes() {
            this.loading = true
            this.restFetchParams(this.observationTypeUrl, {only_numeric: 1}, this.handleTypes)
        },
        handleTypes (response) {
           this.loading = false
           if (response && response.data) {
               this.observationTypes = []
               response.data.forEach(item => {
                   this.observationTypes.push({text: item.name, value: item.id})
               })
           }
        },
        submit: function () {
            this.loading = true
            if (!this.observationType) {
                this.showAlert(this.$t('observation_reports.error_type'))
                return;
            }
            this.report.observation_type = {id: this.observationType}
            this.restAdd(this.observationReportTemplateUrl, this.report, this.success, this.fail)
        },
        success: function () {
            this.loading = false
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_failed'))
        },
    }
}
</script>
<style>
@import "../../../styles/modal.css";
</style>
